import {
  CircleCheckIcon,
  InfoIcon,
  OctagonXIcon,
  TriangleAlertIcon,
} from 'lucide-react';
import { Toaster, type ToasterProps } from 'sonner';

export const Notification = ({
  position = 'bottom-center',
  ...props
}: ToasterProps) => {
  return (
    <Toaster
      icons={{
        success: <CircleCheckIcon aria-hidden className='eye:size-20' />,
        info: <InfoIcon aria-hidden className='eye:size-20' />,
        warning: <TriangleAlertIcon aria-hidden className='eye:size-20' />,
        error: <OctagonXIcon aria-hidden className='eye:size-20' />,
      }}
      {...props}
      position={position}
      closeButton={true}
      aria-live='polite'
      toastOptions={{
        style: {
          fontFamily: 'var(--default-font-family)',
        },
        className: 'eye:border-grey-40! eye:shadow-lg!',
        classNames: {
          title: 'eye:text-14!',
          description: 'eye:text-14! eye:text-black!',
          success: 'eye:bg-green-25! eye:text-black!',
          info: 'eye:bg-blue-25! eye:text-black!',
          warning: 'eye:bg-yellow-35! eye:text-black!',
          error: 'eye:bg-red-25! eye:text-black!',
          closeButton:
            'eye:size-24! eye:left-auto! eye:right-[-18px]! eye:top-[-2px]! eye:translate-x-0! eye:translate-y-0! eye:shadow-lg!',
        },
      }}
    />
  );
};
